import type { SpecialPrincipal as SpecialPrincipalModel } from '@/adapters/catalogv1.g';

/**
 * Transform a backend SpecialPrincipal model to a frontend CatalogSpecialPrincipal type.
 * @param model - API SpecialPrincipal response from catalog
 * @returns CatalogSpecialPrincipal - UI-friendly special principal object
 */
export function extractSpecialPrincipal(model: SpecialPrincipalModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    principalRef: model.principal_ref ?? '',
    kind: model.kind ?? '',
    name: model.name ?? '',
    scope: model.scope ?? '',
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogSpecialPrincipal = ReturnType<
  typeof extractSpecialPrincipal
>;
